/**
 * @param {number} payment
 * @param {number} startupFee
 * @param {number} monthlyFee
 * @param {number} estimatedPeriodRate
 * @param {number} iteration
 * @returns {number}
 */
function calculatePresentValue ({ payment = 0, startupFee = 0, monthlyFee = 0, estimatedPeriodRate = 0, iteration = 0 } = {}) {
  return (payment + startupFee + monthlyFee) / Math.pow((1 + estimatedPeriodRate), iteration)
}

module.exports = { calculatePresentValue }
